import { API_BASE } from "../api";

export function Loading({ what }: { what: string }) {
  return (
    <div className="card">
      <p className="muted">Loading {what}…</p>
    </div>
  );
}

export function ErrorBox({ error, what }: { error: string; what: string }) {
  const noWorkspace = /no workspace/i.test(error);
  return (
    <div className="card">
      <span className="badge warn">Could not load {what}</span>
      <p style={{ marginTop: 12 }}>{error}</p>
      {noWorkspace ? (
        <p className="muted">
          The database is reachable but empty. Load the demo seed:
          <br />
          <code>npx wrangler d1 execute pms --remote --file=./seed/0001_demo_powersaveme.sql</code>
        </p>
      ) : (
        <p className="muted">
          API: <code>{API_BASE}</code>
        </p>
      )}
    </div>
  );
}

export function Empty({ what }: { what: string }) {
  return (
    <div className="card">
      <p className="muted">No {what} yet.</p>
    </div>
  );
}
